/* LinkAndSyncDetailComponent.js */

"use strict";

const Renderer = require("./LinkAndSyncDetailRenderer");
const EventEmitter = require("events").EventEmitter;

const _ = require("lodash");

class LinkAndSyncDetailComponent extends EventEmitter {
    constructor(logger, GameEditor) {
        super(logger, GameEditor);
        this._logger = logger;
        this._gameEditor = GameEditor;

        this.devices = Array.isArray(this._gameEditor._activeView.selectedRows)
            ? this._gameEditor._activeView.selectedRows
            : [];

        this._title = `Sync Device${this.devices.length === 1 ? "" : "s"} with CMDB`;

        this._showServiceNowOption =
            _.get(this._gameEditor, "_dataSyncServiceNow.enabled", false) !== false;
        this._showNetBoxOption =
            _.get(this._gameEditor, "_dataSyncNetbox.enabled", false) !== false;
        this._showNetBoxAllDeviceOption =
            _.get(this._gameEditor, "_dataSyncNetbox.enabled", false) !== false &&
            _.get(this._gameEditor, "_dataSyncNetbox.createDevices", false) !== false;
        this._showXdOption = _.get(this._gameEditor, "_dataSyncXd.enabled", false) !== false;

        this._orderedSync = {
            serviceNow: this._showServiceNowOption,
            netBox: this._showNetBoxOption,
            xDome: this._showXdOption,
        };

        this._renderer = new Renderer(this);
        this._renderer.render();
        this._context = undefined;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    async shutdown() {
        try {
            await this._renderer.shutdown();
            this._logger = this._title = this._renderer = this._context = undefined;
        } catch (err) {
            this._logger.warn({error: err}, "LinkAndSyncDetailComponent.shutdown() error");
        }
    }

    linkAndSyncAction() {
        this._context.resolve(this._orderedSync ? this._orderedSync : {});
    }

    cancelAction() {
        this._context.reject({userRejected: true});
    }

    set "$teve.ui.context"(context) {
        this._context = context;
    }
}

module.exports = LinkAndSyncDetailComponent;
